// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ae-readme-new_modalContent_AGcbh {
    width: 600px;
    max-height: 80vh;
    overflow-y: auto;
}

.ae-readme-new_body_Jw_MW {
    padding: 1.5rem;
    font-size: 14px;
    line-height: 1.6;
}

.ae-readme-new_body_Jw_MW h1 {
    font-size: 1.5rem;
    margin-bottom: 0.5rem;
}

.ae-readme-new_body_Jw_MW h2 {
    font-size: 1.2rem;
    margin-top: 1rem;
    margin-bottom: 0.5rem;
}

.ae-readme-new_body_Jw_MW h3 {
    font-size: 1.1rem;
    margin-top: 0.8rem;
    margin-bottom: 0.3rem;
}

.ae-readme-new_body_Jw_MW p {
    margin-bottom: 0.5rem;
}

.ae-readme-new_body_Jw_MW code {
    background-color: rgba(0, 0, 0, 0.08);
    padding: 0.1rem 0.3rem;
    border-radius: 3px;
    font-size: 0.9em;
}

.ae-readme-new_body_Jw_MW pre {
    background-color: rgba(0, 0, 0, 0.06);
    padding: 0.8rem;
    border-radius: 4px;
    overflow-x: auto;
}

.ae-readme-new_body_Jw_MW blockquote {
    border-left: 3px solid #ccc;
    margin-left: 0;
    padding-left: 1rem;
    color: #666;
}

.ae-readme-new_body_Jw_MW a {
    color: #4c97ff;
    text-decoration: none;
}

.ae-readme-new_body_Jw_MW a:hover {
    text-decoration: underline;
}`, "",{"version":3,"sources":["webpack://./src/components/ae-readme-new/ae-readme-new.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qCAAqC;IACrC,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,qCAAqC;IACrC,eAAe;IACf,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;IAC3B,cAAc;IACd,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;AAC9B","sourcesContent":[".modalContent {\n    width: 600px;\n    max-height: 80vh;\n    overflow-y: auto;\n}\n\n.body {\n    padding: 1.5rem;\n    font-size: 14px;\n    line-height: 1.6;\n}\n\n.body h1 {\n    font-size: 1.5rem;\n    margin-bottom: 0.5rem;\n}\n\n.body h2 {\n    font-size: 1.2rem;\n    margin-top: 1rem;\n    margin-bottom: 0.5rem;\n}\n\n.body h3 {\n    font-size: 1.1rem;\n    margin-top: 0.8rem;\n    margin-bottom: 0.3rem;\n}\n\n.body p {\n    margin-bottom: 0.5rem;\n}\n\n.body code {\n    background-color: rgba(0, 0, 0, 0.08);\n    padding: 0.1rem 0.3rem;\n    border-radius: 3px;\n    font-size: 0.9em;\n}\n\n.body pre {\n    background-color: rgba(0, 0, 0, 0.06);\n    padding: 0.8rem;\n    border-radius: 4px;\n    overflow-x: auto;\n}\n\n.body blockquote {\n    border-left: 3px solid #ccc;\n    margin-left: 0;\n    padding-left: 1rem;\n    color: #666;\n}\n\n.body a {\n    color: #4c97ff;\n    text-decoration: none;\n}\n\n.body a:hover {\n    text-decoration: underline;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalContent": `ae-readme-new_modalContent_AGcbh`,
	"body": `ae-readme-new_body_Jw_MW`
};
export default ___CSS_LOADER_EXPORT___;
